import { render, staticRenderFns } from "./BrandPartsTypeAddLayer.vue?vue&type=template&id=0e9b6da9&scoped=true&"
import script from "./BrandPartsTypeAddLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsTypeAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsTypeAddLayer.vue?vue&type=style&index=0&id=0e9b6da9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9b6da9",
  null
  
)

export default component.exports